export interface ExamSummaryEntity {
  iconUrl: string;
  title: string;
  content: string;
}
interface CommonContent {
  content: string;
  subContent?: string;
}
export interface CommonContentEntity {
  title: string;
  content: CommonContent[];
  highlight?: string[];
  prevIconUrl?: string;
  prevChar?: string;
}
export interface ExamProcessEntity {
  title: string;
  content: string[];
  subContent?: string[];
}
export interface TheoryExamLicenseEntity {
  webSeq: number;
  mobileSeq: number;
  licenseType: string;
  subLicenseType?: string;
  iconUrl: string;
  passingCriteria: string; // 합격기준
  examEligibility: string; // 시험자격
  fee: number; // 수수료
}

/** 면허취득절차 */
export const EXAM_PROCESSES: ExamProcessEntity[] = [
  {
    title: '응시 전 교통안전 교육',
    content: [
      '학과 시험 전까지 이수 완료',
      '준비물 : 신분증, 학과 시험 전까지 이수',
    ],
  },
  {
    title: '신체검사',
    content: ['시험장 내 신체 검사실 또는 병원에서 검사 진행'],
    subContent: ['※ 문경, 강릉 태백시험장 내 신체검사원 없음'],
  },
  {
    title: '학과 접수',
    content: [
      '준비물 : 응시원서, 신분증, 6개월 이내 촬영한 컬러사진 (3.5 x 4.5cm) 3매',
    ],
  },
  {
    title: '학과 시험',
    content: ['불합격 시 : 불합격 다음날부터 재응시 가능'],
  },
  {
    title: '기능 접수',
    content: [
      '준비물 : 응시원서, 신분증',
      '대리접수 : 대리인 신분증 및 위임자의 위임장',
    ],
  },
  {
    title: '기능 시험',
    content: ['불합격 시 : 불합격일로부터 3일 경과 후 재응시 가능'],
  },
  {
    title: '연습면허 발급',
    content: [
      '제 1,2종 보통면허시험 응시자로, 학과시험 및 장내기능 시험에 모두 합격한 자',
    ],
  },
  {
    title: '도로주행 접수',
    content: [
      '준비물 : 응시원서(연습면허 부착), 신분증',
      '대리접수 : 대리인의 신분증 및 위임자의 위임장',
    ],
  },
  {
    title: '도로주행 시험',
    content: ['불합격 시 : 불합격일로부터 3일 경과 후 재응시 가능'],
  },
  {
    title: '운전면허증 발급',
    content: [
      '제 1, 2종 보통면허 : 연습면허 취득 후 도로주행 시험에 합격한 자',
      '기타면허 : 학과시험, 기능시험에 합격한 자',
    ],
  },
] as const;

/** 학과시험 */
export const CAUTION_THEORY_EXAM_TITLE = '안내사항';
export const CAUTION_THEORY_EXAM_CONTENT = `- 전국 운전면허시험장에서 평일 09:00 ~ 17:00 응시접수 가능합니다. (청각장애인 및 비문해자 학과시험은 오전 10:30까지, 오후 16:30까지 응시접수 완료)
- 21.03.22 학과시험 인터넷 예약제 시행`;

export const THEORY_EXAM_SUMMARY: ExamSummaryEntity[] = [
  {
    iconUrl: '/images/exam/theory/icon_timer.svg',
    title: '시험시간',
    content: '40분',
  },
  {
    iconUrl: '/images/exam/theory/icon_type.svg',
    title: '시험유형',
    content: '객관식 (선다형)',
  },
  {
    iconUrl: '/images/exam/theory/icon_language.svg',
    title: '응시 가능 언어',
    content: '한국어, 영어, 중국어, 베트남어',
  },
] as const;

export const THEORY_EXAM_COMMON_LIST: CommonContentEntity[] = [
  {
    title: '시험내용',
    content: [
      {
        content:
          '안전운전에 필요한 교통법규 등 공개된 학과시험 문제은행 중 40문제 출제',
      },
    ],
  },
  {
    title: '준비물',
    content: [
      {
        content: '응시원서(신체검사 완료 또는 건강검진결과서 조회 및 제출)',
      },
      {
        content:
          '신청일로부터 6개월 내에 모자를 벗은 상태에서 배경 없이 촬영된 3.5 x 4.5cm 규격의 상반식 컬러사진(허용되는 사진규격) 3매',
      },
      {
        content: '신분증(신분증 인정 범위)',
      },
    ],
    prevChar: '-',
  },
  {
    title: '결과발표',
    content: [
      {
        content: '시험 종료 즉시 컴퓨터 모니터에 획득 점수 및 합격 여부 표시',
      },
      {
        content: '합격 또는 불합격 도장이 찍힌 응시원서를 돌려받아 본인이 보관',
      },
    ],
    prevChar: '-',
  },
  {
    title: '주의사항',
    content: [
      {
        content: '학과시험 최초응시 일로부터 1년 이내 학과시험에 합격하여야 함',
      },
      {
        content: '학과시험 합격일로부터 1년 이내 기능시험에 합격하여야 함',
      },
      {
        content:
          '1년경과 시 기존 원서 폐기 후 학과시험부터 신규 접수하여야 하며 이때 교통안전교육 재수강은 불필요',
      },
    ],
    highlight: [
      '1년 이내 학과시험에 합격',
      '1년 이내 기능시험에 합격',
      '교통안전교육 재수강은 불필요',
    ],
    prevChar: '-',
  },
  {
    title: '비문해자를 위한\npc학과시험',
    content: [
      {
        content:
          '시험문제와 보기를 음성으로 들을 수 있는 PC학과시험 시험시간 총 80분,\n민원실에서 접수 시 신청가능',
      },
    ],
  },
  {
    title: '청각장애인을 위한\n수화 PC학과시험',
    content: [
      {
        content:
          '청각장애인이면서 비문해자를 위한 수화로 보는 PC학과시험 시험기간 총 80분,\n민원실에서 접수 시 신청 가능',
      },
    ],
  },
] as const;

export const THEORY_EXAM_LICENSE_LIST: TheoryExamLicenseEntity[] = [
  {
    webSeq: 3,
    mobileSeq: 1,
    licenseType: '2종 보통',
    passingCriteria: '60점 이상 시 합격',
    examEligibility: '18세 이상 부터 가능',
    fee: 10000,
    iconUrl: '/images/exam/theory/icon_class_2.svg',
  },
  {
    webSeq: 2,
    mobileSeq: 2,
    licenseType: '1종 보통',
    passingCriteria: '70점 이상 시 합격',
    examEligibility: '18세 이상 부터 가능',
    fee: 10000,
    iconUrl: '/images/exam/theory/icon_class_1.svg',
  },
  {
    webSeq: 1,
    mobileSeq: 3,
    licenseType: '1종 대형',
    subLicenseType: '(대형견인,소형견인,구난차)',
    passingCriteria: '70점 이상 시 합격',
    examEligibility: '19세 이상,\n1ㆍ2종 보통면허 취득\n1년 경과 후 가능',
    fee: 10000,
    iconUrl: '/images/exam/theory/icon_class_1_big.svg',
  },
  {
    webSeq: 4,
    mobileSeq: 4,
    licenseType: '2종 소형',
    subLicenseType: '(125cc 초과 이륜자동차)',
    passingCriteria: '60점 이상 시 합격',
    examEligibility: '18세 이상 부터 가능',
    fee: 10000,
    iconUrl: '/images/exam/theory/icon_class_2_small.svg',
  },
  {
    webSeq: 5,
    mobileSeq: 5,
    licenseType: '2종 원동기',
    subLicenseType: '(125cc 이하)',
    passingCriteria: '60점 이상 시 합격',
    examEligibility: '16세 이상 부터 가능',
    fee: 8000,
    iconUrl: '/images/exam/theory/icon_class_2_motorcycle.svg',
  },
] as const;

/** 장내기능시험 */
export const SKILL_EXAM_SUMMARY: ExamSummaryEntity[] = [
  {
    iconUrl: '/images/exam/icon_type.svg',
    title: '면허종별',
    content: '제 1,2종 보통(수동/자동)',
  },
  {
    iconUrl: '/images/exam/icon_pass.svg',
    title: '합격기준',
    content: '80점 이상 시 합격',
  },
  {
    iconUrl: '/images/exam/icon_fee.svg',
    title: '수수료',
    content: '25,000원',
  },
] as const;

export const SKILL_EXAM_COMMON_LIST: CommonContentEntity[] = [
  {
    title: '준비물',
    content: [
      { content: '온라인 접수 또는 현장 예약 접수' },
      { content: '시험 당일 연습면허 발급 부착된 응시원서, 신분증 지참' },
    ],
    prevChar: '-',
  },
  {
    title: '시험코스',
    content: [
      {
        content:
          '주행거리 300m 이상, 운전장치 조작, 차로 준수 및 급정지, 경사로',
      },
      { content: '좌회전 및 우회전, 주차, 신호교차로, 전진(가속구간)' },
    ],
    prevChar: '-',
  },
  {
    title: '실격기준',
    content: [
      {
        content:
          '점검이 시작될 때부터 종료될 때까지 좌석 안전띠를 착용하지 아니할 때',
      },
      {
        content:
          '시험 중 안전사고를 일으키거나 차의 바퀴 어느 하나라도 연석을 접촉할 때',
      },
      {
        content:
          '시험관의 지시나 통제를 따르지 않거나 음주, 과로, 마약 및 대마 등 약물 등의 영향으로 정상적인 시험 진행이 어려울 때',
      },
      {
        content:
          '특별한 사유 없이 출발 지시 후 출발선에서 30초 이내 출발하지 못할 때',
      },
      {
        content:
          '각 시험 코스를 어느 하나라도 시도하지 않거나 제대로 이행하지 않을 때',
        subContent:
          '* 예시 : 경사로에서 미정지 통과, 직각 주차에서 차고에 진입해서 확인선 미 접촉, 가속코스에서 기어변속을 하지 않음',
      },
      {
        content:
          '경사로 정지 구간 이행 후 30초를 초과하여 통과하지 못할 때 또는 경사로 정지 구간에서 후방으로 1m이상 밀릴 때',
      },
      {
        content:
          '신호 교차로에서 신호위반을 하거나 또는 앞 범퍼가 정지선을 넘어갈 때',
      },
    ],
    prevIconUrl: '/images/exam/icon_x.svg',
  },
  {
    title: '주의사항',
    content: [
      {
        content: '학과시험 합격일로부터 1년 이내 기능 시험에 합격하여야 함.',
      },
      {
        content:
          '1년 경과 시 기존 원서 폐기 후 학과시험부터 신규 접수하여야 하며 이때 응시 전 교통안전교육 재수강은 불필요',
      },
    ],
    prevChar: '-',
  },
  {
    title: '불합격 후 재응시',
    content: [
      {
        content:
          '기능시험 불합격자(운전전문학원 불합격 포함)는 불합격 일로부터 3일 경과 후에 재응시 가능',
        subContent:
          '* 예시 : 1일(월요일)에 불합격하였을 경우, 4일(목요일)부터 재응시 가능)',
      },
    ],
    prevChar: '-',
  },
] as const;

/** 도로주행시험 */
export const ROAD_EXAM_SUMMARY: ExamSummaryEntity[] = [
  {
    iconUrl: '/images/exam/icon_type.svg',
    title: '면허종별',
    content: '제 1,2종 보통(수동/자동)',
  },
  {
    iconUrl: '/images/exam/icon_pass.svg',
    title: '합격기준',
    content: '70점 이상 시 합격',
  },
  {
    iconUrl: '/images/exam/icon_fee.svg',
    title: '수수료',
    content: '30,000원',
  },
] as const;

export const ROAD_EXAM_COMMON_LIST: CommonContentEntity[] = [
  {
    title: '준비물',
    content: [
      { content: '온라인 접수 또는 현장 예약 접수' },
      { content: '시험 당일 연습면허 발급 부착된 응시원서, 신분증 지참' },
    ],
    prevChar: '-',
  },
  {
    title: '시험코스',
    content: [
      {
        content: '총 연장거리 5km 이상인 4개 코스 중 추첨을 통한 1개 코스 선택',
      },
      { content: '내비게이션 음성 길 안내' },
    ],
    prevChar: '-',
  },
  {
    title: '시험내용',
    content: [
      {
        content:
          '긴급자동차 양보, 어린이보호구역, 지정 속도 위반 등 안전운전에 필요한 57개 항목을 평가',
      },
    ],
    highlight: ['57개 항목을 평가'],
  },
  {
    title: '실격기준',
    content: [
      {
        content:
          '3회 이상 [출발 불능], [클러치 조작 불량으로 인한 엔진 정지], [급브레이크 사용], [급조작 및 급출발] 또는\n그 밖의 사유로 운전능력이 현저하게 부족한 것으로 인정할 수 있는 행위를 한 경우',
      },
      {
        content:
          '안전거리 미확보나 경사로에서 뒤로 1미터 이상 밀리는 현상 등운전능력 부족으로\n교통사고를 일으킬 위험이 현저한 경우 또는 교통사고를 야기한 경우',
      },
      {
        content:
          '음주, 과로, 마약, 대마 등 약물의 영향이나 휴대전화 사용 등으로 정상적으로 운전하지 못할\n우려가 있거나 교통안전과 소통을 위한 시험관의 지시 및 통제에 불응한 경우',
      },
      { content: '신호 또는 지시에 따르지 않은 경우' },
      { content: '보행자 보호의무 등을 소홀히 한 경우' },
      {
        content:
          '어린이 보호구역, 노인 및 장애인 보호구역에 지정되어 있는 최고 속도를 초과한 경우',
      },
      {
        content:
          '도로의 중앙으로부터 우측 부분을 통행하여야 할 의무를 위반할 경우',
      },
      {
        content:
          '법령 또는 안전표지 등으로 지정되어 있는 최고 속도를 시속 10km 초과한 경우',
      },
      {
        content:
          '긴급자동차의 우선통행 시 일시정지하거나 진로를 양보하지 않은 경우',
      },
      { content: '어린이 통학버스의 특별보호의무를 위반한 경우' },
      { content: '시험기간 동안 좌석안전띠를 착용하지 않은 경우' },
    ],
    prevIconUrl: '/images/exam/icon_x.svg',
  },
  {
    title: '주의사항',
    content: [
      {
        content:
          '연습운전면허 유효기간(발급일로부터 1년) 이내 도로주행시험에 합격하여야 함.',
      },
      {
        content:
          '연습운전면허 유효기간이 지났을 경우, 도로주행시험 접수가 불가능하며 학과시험, 기능시험에 재응시하여야 함.\n(응시 전 교통안전교육은 재수강 불필요)',
      },
    ],
    prevChar: '-',
  },
] as const;
